import { render, staticRenderFns } from "./ScreenshotPreview.vue?vue&type=template&id=19aa0150&scoped=true&"
import script from "./ScreenshotPreview.vue?vue&type=script&lang=js&"
export * from "./ScreenshotPreview.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotPreview.vue?vue&type=style&index=0&id=19aa0150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa0150",
  null
  
)

export default component.exports